/* ══════════════════════════════════════════════════════════════════════
   COUCHE RÉTENTION — Claude, 2026-09-15. Voir `kelvin-retention.css`.
   Vanilla, sans dépendance : « aucun template tiers », CLAUDE.md.

   Ce fichier N'AJOUTE AUCUN appel à /cart/add.js. Les boutons qu'il
   affiche portent `data-ajout` et sont pris en charge par le
   gestionnaire d'ajout rapide déjà écrit par Qwen dans
   `kelvin-motion-la.js`, toast de confirmation compris. Deux
   gestionnaires sur le même bouton enverraient deux POST.
   ══════════════════════════════════════════════════════════════════════ */
(function () {
  'use strict';

  var racine = document.documentElement;
  var doux = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Un seul écouteur de défilement pour toute la couche, cadencé par
     requestAnimationFrame : pendant un défilement au trackpad, l'évènement
     part plus souvent que l'écran ne se rafraîchit. */
  var abonnes = [];
  var enAttente = false;
  function surDefilement(fn) {
    abonnes.push(fn);
  }
  function cadencer() {
    if (enAttente) return;
    enAttente = true;
    window.requestAnimationFrame(function () {
      enAttente = false;
      var y = window.scrollY || window.pageYOffset || 0;
      for (var i = 0; i < abonnes.length; i++) {
        try {
          abonnes[i](y);
        } catch (e) {}
      }
    });
  }
  window.addEventListener('scroll', cadencer, { passive: true });
  window.addEventListener('resize', cadencer);

  /* ── 0. Rien du premier écran ne doit attendre un défilement ────────
     Voir `kelvin-correctifs.css` §7. Le révélateur de Qwen déclenche à
     75 % de la hauteur de fenêtre ; tout ce qui est plus bas dans le
     PREMIER écran reste donc à `opacity:0` au chargement — sur un écran
     de 900 px, cela comprenait les deux boutons d'achat du hero.

     On marque ici ce qui est déjà visible à l'arrivée. `kr-vu` est plus
     spécifique que la règle de masquage : même si l'observateur retire
     `is-visible` à son premier passage, le contenu reste affiché.
     Ce qui est sous le pli n'est pas touché et garde sa révélation. */
  (function premierEcran() {
    function marquer() {
      var h = window.innerHeight;
      Array.prototype.forEach.call(
        document.querySelectorAll('.la-monte, .la-reveal, .la-ligne'),
        function (el) {
          var r = el.getBoundingClientRect();
          /* Mesuré au chargement, donc en haut de page : `top` est déjà
             la distance au pli. La marge de 4 px évite de rater un
             élément posé pile sur la limite. */
          if (r.top < h - 4 && r.bottom > 0) el.classList.add('kr-vu');
        }
      );
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', marquer);
    } else {
      marquer();
    }
    /* Les polices et la vidéo décalent la mise en page : on repasse une
       fois tout chargé, tant que le visiteur n'a pas encore défilé. */
    window.addEventListener('load', function () {
      if ((window.scrollY || 0) < 4) marquer();
    });
  })();

  /* ── 1. Progression de lecture ──────────────────────────────────── */
  (function progression() {
    var jauge = document.querySelector('.kr-progres__jauge');
    if (!jauge) return;
    surDefilement(function (y) {
      var course = document.documentElement.scrollHeight - window.innerHeight;
      var part = course > 0 ? Math.min(1, Math.max(0, y / course)) : 0;
      jauge.style.transform = 'scaleX(' + part.toFixed(4) + ')';
    });
  })();

  /* ── 2. Indice de défilement sous le hero ───────────────────────── */
  (function indice() {
    var hero = document.querySelector('[class*="sq--hero"], [class*="hero-cadre"], .la-hero');
    if (!hero || doux) return;
    if (getComputedStyle(hero).position === 'static') hero.style.position = 'relative';
    var cue = document.createElement('div');
    cue.className = 'kr-cue';
    cue.setAttribute('aria-hidden', 'true');
    cue.innerHTML = '<span class="kr-cue__trait"></span>';
    hero.appendChild(cue);
    surDefilement(function (y) {
      racine.classList.toggle('kr-parti', y > 40);
    });
  })();

  /* ── 3. Compteur des chiffres ───────────────────────────────────────
     « 27,80 € » se décompose en préfixe / nombre / suffixe. On n'anime
     que le nombre et on garde la ponctuation française : virgule
     décimale, espace insécable avant l'euro. */
  (function compteurs() {
    var cases = document.querySelectorAll('.la-fait__valeur');
    if (!cases.length || !('IntersectionObserver' in window)) return;

    function lire(txt) {
      var m = txt.match(/^(\D*?)([\d  ]+(?:[.,]\d+)?)(.*)$/);
      if (!m) return null;
      var brut = m[2].replace(/[  ]/g, '').replace(',', '.');
      var n = parseFloat(brut);
      if (isNaN(n)) return null;
      var dec = (m[2].split(/[.,]/)[1] || '').length;
      return { avant: m[1], valeur: n, dec: dec, apres: m[3] };
    }

    function ecrire(el, p, n) {
      var s = n.toFixed(p.dec).replace('.', ',');
      el.textContent = p.avant + s + p.apres;
    }

    var obs = new IntersectionObserver(
      function (entrees) {
        entrees.forEach(function (e) {
          if (!e.isIntersecting) return;
          var el = e.target;
          obs.unobserve(el);
          var p = lire(el.textContent.trim());
          if (!p) return;
          el.setAttribute('data-kr-compteur', '');
          if (doux) return;
          var debut = null;
          var duree = 1100;
          var fini = false;
          /* Ce chiffre est un MONTANT. Une animation interrompue —
             onglet mis en arrière-plan, `requestAnimationFrame` privé de
             temps — laisserait « 25,79 € » à l'écran à la place de
             27,80 €, c'est-à-dire un prix faux. D'où cette garantie :
             quoi qu'il arrive, la valeur exacte est écrite à l'échéance,
             et à tout retour de l'onglet au premier plan. */
          function poser() {
            if (fini) return;
            fini = true;
            ecrire(el, p, p.valeur);
          }
          function pas(t) {
            if (fini) return;
            if (debut === null) debut = t;
            var k = Math.min(1, (t - debut) / duree);
            /* easeOutExpo : l'essentiel du comptage se fait tôt, la fin
               se pose — c'est ce qui rend le chiffre lisible en route. */
            var e2 = k === 1 ? 1 : 1 - Math.pow(2, -10 * k);
            ecrire(el, p, p.valeur * e2);
            if (k < 1) window.requestAnimationFrame(pas);
            else poser();
          }
          window.requestAnimationFrame(pas);
          window.setTimeout(poser, duree + 400);
          document.addEventListener('visibilitychange', function () {
            if (!document.hidden) poser();
          });
        });
      },
      { threshold: 0.6 }
    );
    Array.prototype.forEach.call(cases, function (el) {
      obs.observe(el);
    });
  })();

  /* ── 4. La bande prend la vitesse du défilement ─────────────────────
     La durée d'origine est posée en style en ligne par Qwen. On la relève
     AVANT de la surcharger, sinon le facteur s'appliquerait à une valeur
     déjà modifiée et la bande accélérerait sans fin. */
  (function bande() {
    var piste = document.querySelector('.la-bande__piste');
    if (!piste || doux) return;
    var duree = piste.style.animationDuration || getComputedStyle(piste).animationDuration || '45s';
    racine.style.setProperty('--kr-bande-duree', duree);

    var dernier = window.scrollY || 0;
    var facteur = 1;
    var cible = 1;
    surDefilement(function (y) {
      var v = Math.abs(y - dernier);
      dernier = y;
      /* 0 → ×1 (repos), 120 px par image → ×3,2 au plus. */
      cible = 1 + Math.min(2.2, v / 55);
    });
    (function boucle() {
      /* Retour au repos amorti : sans lissage, la bande claque à chaque
         arrêt du doigt. */
      facteur += (cible - facteur) * 0.09;
      cible += (1 - cible) * 0.06;
      racine.style.setProperty('--kr-bande', facteur.toFixed(3));
      window.requestAnimationFrame(boucle);
    })();
  })();

  /* ── 5. Barre d'achat collante ──────────────────────────────────────
     Visible entre la fin de la grille produits et l'appel final. En bas
     de page l'appel occupe l'écran : garder la barre y mettrait deux
     boutons d'achat concurrents sous les yeux. */
  (function barre() {
    var barre = document.querySelector('[data-kr-achat]');
    if (!barre) return;
    barre.hidden = false;

    var grille = document.querySelector('.la-offre__grille, .sq--offre');
    var final = document.querySelector('.sq--appel, [class*="appel"]');
    var finalVisible = false;
    var popOuverte = false;

    if (final && 'IntersectionObserver' in window) {
      new IntersectionObserver(
        function (e) {
          finalVisible = e[0].isIntersecting;
          maj(window.scrollY || 0);
        },
        { threshold: 0.15 }
      ).observe(final);
    }

    function seuil() {
      if (!grille) return window.innerHeight * 0.9;
      var r = grille.getBoundingClientRect();
      /* Elle apparaît quand la grille commence à sortir par le haut :
         le visiteur a vu les produits, il peut décider. */
      return r.top + window.scrollY + r.height * 0.55;
    }

    function maj(y) {
      var visible = y > seuil() && !finalVisible && !popOuverte;
      barre.classList.toggle('is-visible', visible);
      racine.style.setProperty('--kr-h-achat', visible ? barre.offsetHeight + 'px' : '0px');
    }
    surDefilement(maj);
    maj(window.scrollY || 0);

    document.addEventListener('kr:pop', function (e) {
      popOuverte = !!(e.detail && e.detail.ouvert);
      maj(window.scrollY || 0);
    });
  })();

  /* ── 6. Compte à rebours ────────────────────────────────────────────
     Vise une date FIXE, lue dans `data-fin` (la date d'expiration réelle du
     code dans l'Admin). Il ne se relance jamais : même valeur pour tous les
     visiteurs, à la seconde. Passé l'échéance, tout ce qui porte
     `data-kr-offre` ou appartient à l'offre est retiré de la page. */
  function finOffre(el) {
    var t = Date.parse(el && el.getAttribute('data-fin'));
    return isNaN(t) ? 0 : t;
  }
  function deux(n) {
    return n < 10 ? '0' + n : String(n);
  }
  function formate(ms, court) {
    var s = Math.max(0, Math.floor(ms / 1000));
    var j = Math.floor(s / 86400);
    var h = Math.floor((s % 86400) / 3600);
    var m = Math.floor((s % 3600) / 60);
    var sec = s % 60;
    if (court) return (j ? j + ' j ' : '') + deux(h) + ':' + deux(m) + ':' + deux(sec);
    return (j ? j + ' j ' : '') + deux(h) + ' h ' + deux(m) + ' min ' + deux(sec) + ' s';
  }
  var offreFinie = false;
  (function compte() {
    var els = document.querySelectorAll('[data-kr-compte]');
    if (!els.length) return;
    function tic() {
      var maintenant = Date.now();
      var fini = false;
      els.forEach(function (el) {
        var fin = finOffre(el);
        if (!fin || maintenant >= fin) {
          fini = true;
          return;
        }
        el.textContent = formate(fin - maintenant, el.hasAttribute('data-court'));
      });
      if (fini) {
        offreFinie = true;
        document.querySelectorAll('[data-kr-offre], .kr-compte, [data-kr-pastille]').forEach(function (el) {
          el.hidden = true;
        });
        document.dispatchEvent(new CustomEvent('kr:offre-finie'));
        return;
      }
      window.setTimeout(tic, 1000 - (maintenant % 1000));
    }
    tic();
  })();

  /* ── 7. Pop-up de bienvenue ─────────────────────────────────────────
     Trois déclencheurs, le premier qui tombe : sortie du curseur par le
     haut (bureau), seuil de défilement, délai. Une fois vue, elle ne
     revient pas seule avant N jours — mais la pastille la rouvre.

     `kelvin-popup-v1` est la clé que posent déjà les scripts d'audit de
     `tools/shots/` pour neutraliser la pop-up. On la respecte : sinon
     chaque capture et chaque contrôle de non-régression se ferait
     derrière un voile. Elle coupe aussi la pastille. */
  (function popup() {
    var pop = document.querySelector('[data-kr-pop]');
    if (!pop) return;
    var pastille = document.querySelector('[data-kr-pastille]');

    var CLE = 'kelvin-pop-v3';
    var CLE_AUDIT = 'kelvin-popup-v1';
    var CLE_INSCRIT = 'kelvin-bienvenue-inscrit';
    var jours = parseInt(pop.getAttribute('data-jours'), 10) || 7;
    var delai = (parseInt(pop.getAttribute('data-delai'), 10) || 18) * 1000;
    var seuil = (parseInt(pop.getAttribute('data-seuil'), 10) || 55) / 100;

    var fin = finOffre(pop);
    if (!fin || Date.now() >= fin) {
      pop.remove();
      if (pastille) pastille.remove();
      return;
    }

    function stocke(k, v) {
      try {
        window.localStorage.setItem(k, v);
      } catch (e) {}
    }
    function lit(k) {
      try {
        return window.localStorage.getItem(k);
      } catch (e) {
        return null;
      }
    }

    /* Un navigateur privé ou un stockage bloqué fait lever l'accès : on
       considère alors la pop-up comme déjà vue plutôt que de la montrer à
       chaque page. */
    var dispo = true;
    try {
      window.localStorage.setItem('kr-test', '1');
      window.localStorage.removeItem('kr-test');
    } catch (e) {
      dispo = false;
    }
    if (!dispo) return;
    if (lit(CLE_AUDIT)) return;

    /* Retour du formulaire : Shopify recharge la page avec
       `customer_posted=true` et `form.posted_successfully?`. */
    var vientDeSinscrire =
      !!pop.querySelector('[data-kr-inscrit]') || /[?&]customer_posted=true/.test(window.location.search);
    if (vientDeSinscrire) stocke(CLE_INSCRIT, '1');
    var inscrit = !!lit(CLE_INSCRIT);
    var erreur = !!pop.querySelector('[data-kr-erreur]');

    var saisie = pop.querySelector('[data-kr-etape="saisie"]');
    var etapeCode = pop.querySelector('[data-kr-etape="code"]');
    function montreCode() {
      if (saisie) saisie.hidden = true;
      if (etapeCode) etapeCode.hidden = false;
      var arg = pop.querySelector('.kr-pop__arg');
      if (arg) arg.hidden = true;
      var non = pop.querySelector('.kr-pop__non');
      if (non) non.textContent = 'plus tard';
    }
    if (inscrit) montreCode();

    var arme = true;
    var rendu = null;
    var minuteur = null;

    function majPastille() {
      if (!pastille || offreFinie) return;
      pastille.hidden = !pop.hidden || !lit(CLE);
      pastille.classList.toggle('is-code', inscrit);
    }

    function ouvrir(force) {
      if (!arme && !force) return;

      /* ONGLET EN ARRIÈRE-PLAN — mesuré le 2026-09-28.
         `pop.hidden = false` s'exécutait, mais le double `requestAnimationFrame`
         qui pose `is-ouvert` ne tourne pas dans un onglet caché. Résultat : le
         voile plein écran était présent et opaque aux clics pendant que la carte
         restait à `opacity: 0`, hors écran. Un bloqueur invisible, sans croix.
         On reporte l'ouverture au retour sur l'onglet. */
      if (document.visibilityState && document.visibilityState !== 'visible') {
        document.addEventListener('visibilitychange', function relance() {
          if (document.visibilityState === 'visible') {
            document.removeEventListener('visibilitychange', relance);
            ouvrir(force);
          }
        });
        return;
      }

      arme = false;
      window.clearTimeout(minuteur);
      stocke(CLE, String(Date.now()));
      rendu = document.activeElement;
      pop.hidden = false;
      majPastille();
      /* Deux images : l'une pose `hidden=false`, l'autre laisse le
         navigateur calculer l'état de départ avant la transition. */
      /* Filet : si les images sont bridées malgré tout, un minuteur pose la
         classe. Sans lui, le voile resterait affiché sans sa carte. */
      var pose = function () { pop.classList.add('is-ouvert'); };
      window.requestAnimationFrame(function () {
        window.requestAnimationFrame(pose);
      });
      window.setTimeout(pose, 120);
      var premier = pop.querySelector(inscrit ? '.kr-code' : '.kr-pop__champ');
      if (!premier || premier.offsetParent === null) premier = pop.querySelector('.kr-pop__x');
      if (premier) premier.focus({ preventScroll: true });
      document.dispatchEvent(new CustomEvent('kr:pop', { detail: { ouvert: true } }));
    }

    function fermer() {
      if (pop.hidden) return;
      pop.classList.remove('is-ouvert');
      document.dispatchEvent(new CustomEvent('kr:pop', { detail: { ouvert: false } }));
      var fin = function () {
        pop.hidden = true;
        majPastille();
        if (rendu && rendu.focus) rendu.focus({ preventScroll: true });
      };
      if (doux) fin();
      else window.setTimeout(fin, 420);
    }

    pop.querySelectorAll('[data-kr-fermer]').forEach(function (b) {
      b.addEventListener('click', fermer);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') fermer();
    });
    if (pastille) {
      pastille.addEventListener('click', function () {
        ouvrir(true);
      });
    }

    /* Copie du code. Le presse-papiers exige une page sécurisée : sinon, on
       sélectionne le texte pour que le visiteur le copie lui-même. */
    pop.querySelectorAll('[data-kr-copier]').forEach(function (b) {
      b.addEventListener('click', function () {
        var etat = b.querySelector('[data-kr-copier-etat]');
        var code = b.getAttribute('data-kr-copier');
        var ok = function () {
          if (etat) etat.textContent = 'copié';
        };
        if (navigator.clipboard && window.isSecureContext) {
          navigator.clipboard.writeText(code).then(ok, function () {});
        } else {
          var r = document.createRange();
          r.selectNodeContents(b.querySelector('.kr-code__txt'));
          var sel = window.getSelection();
          sel.removeAllRanges();
          sel.addRange(r);
        }
      });
    });

    /* Piège au clavier : sans lui, la tabulation sort de la carte et
       continue derrière le voile, où plus rien n'est cliquable. */
    pop.addEventListener('keydown', function (e) {
      if (e.key !== 'Tab' || pop.hidden) return;
      var cibles = Array.prototype.filter.call(
        pop.querySelectorAll('button, a[href], input:not([type="hidden"]), [tabindex]:not([tabindex="-1"])'),
        function (el) {
          return el.offsetParent !== null;
        }
      );
      if (!cibles.length) return;
      var premier = cibles[0];
      var dernier = cibles[cibles.length - 1];
      if (e.shiftKey && document.activeElement === premier) {
        e.preventDefault();
        dernier.focus();
      } else if (!e.shiftKey && document.activeElement === dernier) {
        e.preventDefault();
        premier.focus();
      }
    });

    /* Juste inscrit, ou e-mail refusé : on rouvre tout de suite, pour
       donner le code ou dire ce qui cloche. */
    if (vientDeSinscrire || erreur) {
      ouvrir(true);
      return;
    }

    majPastille();
    var vu = parseInt(lit(CLE), 10);
    if (inscrit || (vu && Date.now() - vu < jours * 86400000)) return;

    minuteur = window.setTimeout(ouvrir, delai);

    surDefilement(function (y) {
      var course = document.documentElement.scrollHeight - window.innerHeight;
      if (course > 0 && y / course >= seuil) ouvrir();
    });

    /* Sortie de souris par le haut de la fenêtre : le geste de quitter.
       Inutile au doigt, d'où le test du pointeur fin. */
    if (window.matchMedia('(pointer:fine)').matches) {
      document.addEventListener('mouseout', function (e) {
        if (e.clientY <= 0 && !e.relatedTarget) ouvrir();
      });
    }
  })();
})();
